import React from "react";
export default function VerticalFlexContainer({
  flex,
  children,
  height,
  width,
  align,
  justify,
  paddingHorizontal,
  paddingVertical,
  maxWidth,
}) {
  return (
    <div
      style={{
        display: "flex",
        flexDirection: "column",
        flex: flex,
        margin: 0,
        height: height,
        width: width,
        maxWidth: maxWidth,
        alignItems: align,
        justifyContent: justify,
        padding: `${paddingVertical} ${paddingHorizontal}`,
      }}
    >
      {children}
    </div>
  );
}
